import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { ClerkProvider } from './components/auth/ClerkProvider';
import { AuthProvider } from './contexts/AuthContext';
import App from './App.tsx';
import './index.css';
import './globals.css';

// Importar configuración i18n
import './i18n';
import i18n from './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider>
      <AuthProvider>
        <I18nextProvider i18n={i18n}>
          <Suspense fallback={<div>Loading translations...</div>}>
            <App />
          </Suspense>
        </I18nextProvider>
      </AuthProvider>
    </ClerkProvider>
  </React.StrictMode>
);
